import createIcon from '../../createIcon';

/**
 * @component @name Save
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgM0g1QzMuODkgMyAzIDMuOSAzIDVWMTlDMyAyMC4xIDMuODkgMjEgNSAyMUgxOUMyMC4xIDIxIDIxIDIwLjEgMjEgMTlWN0wxNyAzWk0xMiAxOUMxMC4zNCAxOSA5IDE3LjY2IDkgMTZDOSAxNC4zNCAxMC4zNCAxMyAxMiAxM0MxMy42NiAxMyAxNSAxNC4zNCAxNSAxNkMxNSAxNy42NiAxMy42NiAxOSAxMiAxOVpNMTUgOUg1VjVIMTVWOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Save = createIcon('Save', [
  [
    'path',
    {
      d: 'M17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V7L17 3ZM12 19C10.34 19 9 17.66 9 16C9 14.34 10.34 13 12 13C13.66 13 15 14.34 15 16C15 17.66 13.66 19 12 19ZM15 9H5V5H15V9Z',
      key: 'rr6g9c',
    },
  ],
]);

export default Save;
